import PropTypes from "prop-types";
import { useEffect } from "react";
import CraneLoader from "./CraneLoader";

const ProcessingScreen = ({ show, title, message }) => {
  useEffect(() => {
    if (!show) return;

    const blockKeys = (e) => {
      e.stopPropagation();
      e.preventDefault();
    };
    const warnOnLeave = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };

    document.body.classList.add("overflow-hidden");
    document.addEventListener("keydown", blockKeys, true);
    window.addEventListener("beforeunload", warnOnLeave);

    return () => {
      document.body.classList.remove("overflow-hidden");
      document.removeEventListener("keydown", blockKeys, true);
      window.removeEventListener("beforeunload", warnOnLeave);
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      className="ProcessingScreen position-fixed top-0 start-0 vw-100 vh-100 d-flex align-items-center justify-content-center"
      role="alertdialog"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="processing-card">
        <CraneLoader label={typeof title === "string" ? title : "Crane"} />
        {title && <div className="processing-title">{title}</div>}
        {message && <div className="processing-message">{message}</div>}
      </div>
    </div>
  );
};

ProcessingScreen.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.node,
  message: PropTypes.node,
};

export default ProcessingScreen;
